module.exports = __webpack_public_path__ + "img/setxrm-is-akis-yonetimi.9ba898ff.png";